export const STANDARD_EDITOR = {
  ASSOCIATED_DOCUMENTS: 'Documentos Asociados',
  ASSOCIATED_EVIDENCES: 'Evidencias Asociadas',
  NO_DOCUMENTS: 'No hay documentos',
  NO_EVIDENCES: 'No hay evidencias',
  NO_CODE: 'Sin código',
  NO_DESCRIPTION: 'Sin descripción',
  NO_IMPLEMENTATION_GUIDE: 'Sin guía de implementación',
  NO_STANDARDS: 'Sin estándares',
  TYPE: 'Tipo',
  CONTROL_DETAILS: 'Detalles del Control',
  DOCUMENT_DETAILS: 'Detalles del Documento',
  EVIDENCE_DETAILS: 'Detalles de la Evidencia',
  SELECT_DOCUMENT: 'Seleccionar un documento...',
  SELECT_EVIDENCE: 'Seleccionar una evidencia...',
  DELETE_CONTROL_TITLE: 'Eliminar Control',
  DELETE_CONTROL_QUESTION: '¿Estás seguro de que quieres eliminar',
  DELETE_CONTROL_IMPACT: (count: number) =>
    `Esto eliminará el control de ${count} organización${count === 1 ? '' : 'es'}.`,
  DELETE_CONTROL_CONFIRMATION: 'Esta acción no se puede deshacer.',
  DELETE_DOCUMENT_TITLE: 'Eliminar Documento',
  DELETE_DOCUMENT_QUESTION: '¿Estás seguro de que quieres eliminar',
  DELETE_DOCUMENT_CONFIRMATION: 'Esta acción no se puede deshacer.',
  DELETE_DOCUMENT_IMPACT: (count: number) =>
    `Esto eliminará el documento de ${count} organización${count === 1 ? '' : 'es'}.`,
  DELETE_DOCUMENT_WARNING_TITLE: 'Eliminar Documento — Se Requiere Confirmación',
  DELETE_DOCUMENT_WARNING_INTRO: 'Este documento contiene datos modificados por usuarios en organizaciones adoptantes:',
  DELETE_DOCUMENT_WARNING_SIGNATURES: (count: number) =>
    `${count} ${count === 1 ? 'usuario ha firmado' : 'usuarios han firmado'} esta política. Al eliminarla se borrará${count === 1 ? '' : 'n'} su${count === 1 ? '' : 's'} firma${count === 1 ? '' : 's'}.`,
  DELETE_DOCUMENT_WARNING_FILES: (count: number) =>
    `Se eliminará${count === 1 ? '' : 'n'} ${count} archivo${count === 1 ? '' : 's'} personalizado${count === 1 ? '' : 's'}.`,
  DELETE_DOCUMENT_WARNING_LINKS: (count: number) =>
    `Se eliminará${count === 1 ? '' : 'n'} ${count} enlace${count === 1 ? '' : 's'} personalizado${count === 1 ? '' : 's'}.`,
  DELETE_DOCUMENT_WARNING_ORGS_WITH_WORK: (count: number) =>
    `${count} ${count === 1 ? 'organización tiene' : 'organizaciones tienen'} progreso en este documento.`,
  DELETE_DOCUMENT_WARNING_STANDARDS: 'También está vinculado a través de los siguientes estándares:',
  DELETE_DOCUMENT_WARNING_CONFIRM: 'Entiendo y deseo proceder',
  DELETE_EVIDENCE_TITLE: 'Eliminar Evidencia',
  DELETE_EVIDENCE_QUESTION: '¿Estás seguro de que quieres eliminar',
  DELETE_EVIDENCE_CONFIRMATION: 'Esta acción no se puede deshacer.',
  DELETE_EVIDENCE_IMPACT: (count: number) =>
    `Esto eliminará la evidencia de ${count} organización${count === 1 ? '' : 'es'}.`,
  DELETE_EVIDENCE_WARNING_TITLE: 'Eliminar Evidencia — Se Requiere Confirmación',
  DELETE_EVIDENCE_WARNING_INTRO: 'Esta evidencia contiene datos modificados por usuarios en organizaciones adoptantes:',
  DELETE_EVIDENCE_WARNING_FILES: (count: number) =>
    `Se eliminará${count === 1 ? '' : 'n'} ${count} archivo${count === 1 ? '' : 's'} subido${count === 1 ? '' : 's'}.`,
  DELETE_EVIDENCE_WARNING_LINKS: (count: number) =>
    `Se eliminará${count === 1 ? '' : 'n'} ${count} enlace${count === 1 ? '' : 's'} adjunto${count === 1 ? '' : 's'}.`,
  DELETE_EVIDENCE_WARNING_ORGS_WITH_WORK: (count: number) =>
    `${count} ${count === 1 ? 'organización tiene' : 'organizaciones tienen'} progreso en esta evidencia.`,
  DELETE_EVIDENCE_WARNING_STANDARDS: 'También está vinculada a través de los siguientes estándares:',
  DELETE_EVIDENCE_WARNING_CONFIRM: 'Entiendo y deseo proceder',
  VALIDATION_CONTROL_REQUIRED: 'Los datos del control son requeridos',
  VALIDATION_DOCUMENT_REQUIRED: 'Los datos del documento son requeridos',
  VALIDATION_EVIDENCE_REQUIRED: 'Los datos de la evidencia son requeridos',
  VALIDATION_NAME_REQUIRED: 'Nombre',
  VALIDATION_DESCRIPTION_REQUIRED: 'Descripción',
  VALIDATION_IMPLEMENTATION_GUIDE_REQUIRED: 'Guía de Implementación',
  VALIDATION_TITLE: 'Campos Requeridos Faltantes',
  VALIDATION_MESSAGE: 'Por favor completa los siguientes campos requeridos antes de crear:',
  VALIDATION_BASIC_FIELDS: 'Campos Básicos:',
  VALIDATION_TRANSLATIONS: 'Traducciones faltantes:',
  NO_DOCUMENT_TYPE: 'Sin tipo de documento',
  DOCUMENT_TYPES: {
    POLICY: 'Política',
    DOCUMENT: 'Documento',
    REGISTER: 'Registro',
    PROCESS: 'Proceso',
    PROCEDURE: 'Procedimiento',
  },
  DOCUMENT_TYPE_SELECTOR: {
    SEARCH_TYPES: 'Buscar tipos de documento...',
    NO_TYPE_FOUND: 'No se encontró tipo de documento',
  },
  PLATFORM_LINK: 'Enlace de plataforma',
  PLATFORM_URL: 'URL de plataforma',
  PLATFORM_URL_PLACEHOLDER: 'ej. /compliance/evidences',
  CAPABILITY: 'Capacidad',
  CAPABILITY_PLACEHOLDER: 'Seleccionar capacidad (opcional)',
  NO_CAPABILITY: 'Ninguna',
}
